define("ember-svg-jar/inlined/custom-analytics", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M25.597 16.497s0-.105-.012-.152c-.012-.07-.047-.128-.058-.187-.035-.14-.082-.268-.129-.408a4.854 4.854 0 00-.443-.968c-.175-.292-2.952-6.429-3.512-7.245a3.024 3.024 0 00-2.881-2.089A3.04 3.04 0 0015.54 8.26h-3.057a3.032 3.032 0 00-3.021-2.812A3.046 3.046 0 006.58 7.537c-.268.385-3.36 6.976-3.512 7.245a4.994 4.994 0 00-.723 2.59 5.084 5.084 0 005.087 5.086 5.084 5.084 0 005.086-5.086v-2.124h3.01v2.124a5.103 5.103 0 003.104 4.69 5.057 5.057 0 001.983.396c.712 0 1.377-.14 1.983-.396a5.09 5.09 0 003.104-4.69 4.37 4.37 0 00-.094-.875h-.011zM7.42 20.417a3.047 3.047 0 01-3.045-3.045 3.047 3.047 0 013.045-3.045 3.047 3.047 0 013.045 3.045 3.047 3.047 0 01-3.045 3.045zm13.183 0a3.047 3.047 0 01-3.045-3.045 3.047 3.047 0 013.045-3.045 3.047 3.047 0 013.045 3.045 3.047 3.047 0 01-3.045 3.045z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});